import { SET_IS_OPEN_REASIGN_MODAL } from '../actionTypes';
import { contactActions } from '../reducer';

export default (value) => contactActions[SET_IS_OPEN_REASIGN_MODAL](value);
